import React from 'react';
import Button from '../../components/Common/Button'; 

import { ReactComponent as NotFoundIcon } from "../../assets/icon/transaction_not_found.svg";

const TransactionNotFoundComponent = () => {
    return (
        <div className="flex flex-col gap-3 flex-1 min-h-[600px] items-center justify-center">
            <div className="flex flex-col gap-2 items-center  p-2">
              
                <NotFoundIcon className=" h-64 aspect-square"/>
                <span className=" text-3xl  font-bold">
                    Maaf, Transaksi Kamu Tidak Ditemukan
                </span>
                <span className=" text-base opacity-60">
                    Wahh..! Nomor Transaksimu tidak valid, Kami tidak dapat menemukan transaksimu
                </span>
                <div className="flex flex-col sm:flex-row flex-1 w-full max-w-lg gap-2">
                    <div className='w-full'>
                        <Button
                            initialValue="Kembali ke pencarian"
                            type="fill"
                            className="bg-[#22BDE2] text-darkColor w-full flex-1"
                            onClick={() => {
                            }}
                        />
                    </div>
                    <div className='w-full'>
                        <Button
                            initialValue="Hubungi pusat bantuan"
                            type="fill"
                            className="border-[#22BDE2] text-[#22BDE2] border-1 w-full flex-1"
                            onClick={() => {
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TransactionNotFoundComponent;
